import type { App } from 'vue';
import { createI18n } from 'vue-i18n';
import type { I18nOptions } from 'vue-i18n';
import { setHtmlPageLang } from './helper';

const createI18nOptions = async (): Promise<I18nOptions> => {
    const { getCurrentLocale } = useStore('locale');
    const lang = getCurrentLocale.value;

    const defaultLocal = await import(`../../locales/${lang}.ts`);

    const message = defaultLocal.default ?? {};
    setHtmlPageLang(lang);

    return {
        legacy: false,
        locale: lang,
        messages: {
            [lang]: message,
        },
    };
};

export const setupI18n = async (app: App<Element>) => {
    const options = await createI18nOptions();
    const i18n = createI18n(options);
    app.use(i18n);
};
